import { getFileSize } from "./utility";

export function isEmail(value){
    return value.includes("@");
}

export function isEmpty(value){
    return value.trim() === "";
}

export function hasMinimumLength(value, length){
    return value.length >= length;
}

export function hasLength(value, length){
    return value.length === length;
}

export function isEqualsToOtherValue(value, otherValue){
    return value === otherValue;
}

export function isInteger(value){
    return /^\d+$/.test(value);
}

export function hasDuplicates(array) {
    var valuesSoFar = Object.create(null);
    for (var i = 0; i < array.length; ++i) {
        var value = array[i];
        if (value in valuesSoFar) {
            return true;
        }
        valuesSoFar[value] = true;
    }
    return false;
}

export const maxFileSize = (file,size) => {
    return file.size <= size;
}